<template>
  <div class="submit-msg">
    <cube-form
      ref="formRef"
      :model="model"
      @validate="validateHandler"
      style="height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
      <div>
        <div v-for="(item,index) in formItem" :key="index">
          <div
            v-if="item !== 'button' && item !== 'userradio' && item !== 'upload'"
            @click="item === 'date' ? (showDatePicker(),dateLocated = index) : null" >
            <cube-form-item :field="{...fields[index], events: { 'blur': onInputBlur }}" style="margin-bottom: 10px;"></cube-form-item>
          </div>
        </div>
      </div>

      <div style="margin-bottom: 10px;">
        <cube-button class="btn-item" @click="submitHandler" >{{btnMsg}}</cube-button>
        <div class="cube-radio-font" style="min-height: 40px;">
          <cube-form-item v-if="showProtocol" :field="fields[fields.length-1]" class="radio-item"></cube-form-item>
        </div>
      </div>
    </cube-form>
  </div>
</template>
<script>
export default {
  name: 'Form',
  props: {
    models: {
      type: Object,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    formFields: {
      type: Array,
      required: true
    },
    btnMsg: {
      type: String
    },
    spaceHeight: {
      type: String
    }
  },
  data () {
    return {
      showProtocol: false,
      isValid: false,
      dateLocated: 0,
      isCanQuery: true,
      queryValue: ''
    }
  },
  computed: {
    model () {
      return this.models
    },
    formItem () {
      return this.items
    },
    fields () {
      return this.formFields
    },
    Title () {
      return this.$store.state.common.Forecast
    }
  },
  mounted () {
    this.showProtocol = this.$route.query.protocol

    const self = this
    this.$refs.formRef.$el.addEventListener('keyup', function (e) {
      if (e.code === 'Enter') {
        self.submitHandler()
      }
    })
  },
  methods: {
    /**
     * 表单校验
     */
    validateHandler (result) {
      console.log(result)
      this.isValid = result.valid
    },
    /**
     * 表单提交，当isValid为true时触发
     */
    submitHandler () {
      if (this.showProtocol && this.models.userValue !== undefined && this.models.userValue === '') {
        this.$createToast({
          time: 1000,
          type: 'txt',
          txt: '请同意用户隐私协议'
        }).show()
        return
      }

      this.$refs.formRef.validate(() => {
        if (this.isValid === true) {
          this.$emit('submitClick')
        }
      })
    },

    showDatePicker () {
      if (!this.datePicker) {
        console.log('show data picker  i=' + this.dateLocated)
        this.datePicker = this.$createDatePicker({
          title: '选择日期',
          showNow: true,
          minuteStep: 1,
          value: new Date(),
          columnCount: 4,
          min: new Date(1920, 0, 1, 0, 0, 0),
          max: new Date(2040, 11, 30, 23, 59, 59),
          format: {
            year: 'YYYY',
            month: 'MM月',
            date: 'DD日',
            hour: 'hh时'
          },
          onSelect: this.selectHandle,
          onCancel: () => {}
        })
      }
      this.datePicker.show()
    },
    selectHandle (date, selectedVal, selectedText) { // 日期选择器选择对应的modelkey
      const dateValue = Object.keys(this.model)
      console.log(selectedText)

      const month = parseInt(selectedText[1]) < 10 ? '0' + parseInt(selectedText[1]) : parseInt(selectedText[1])
      const day = parseInt(selectedText[2]) < 10 ? '0' + parseInt(selectedText[2]) : parseInt(selectedText[2])
      const hour = parseInt(selectedText[3]) < 10 ? '0' + parseInt(selectedText[3]) : parseInt(selectedText[3])
      const myDataValue = parseInt(selectedText[0]) + '年' +
                        month + '月' +
                        day + '日 ' +
                        hour + '时'

      console.log(myDataValue)
      this.model[dateValue[this.dateLocated]] = myDataValue
    },

    onInputBlur () {
      let top = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
      window.scrollTo(0, top + 1)
      setTimeout(() => {
        window.scrollTo(0, top)
      }, 300)
    }

  }
}
</script>

<style lang="stylus" src="@/style/form.styl">

</style>
